import { render, staticRenderFns } from "./Lookups.vue?vue&type=template&id=6aedcf04&"
import script from "./Lookups.vue?vue&type=script&lang=js&"
export * from "./Lookups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports